"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onEnterOrSpacePress = exports.onEnterPress = exports.onKeyboardKey = exports.DefinedKeyboardKeys = void 0;
var DefinedKeyboardKeys;
(function (DefinedKeyboardKeys) {
    DefinedKeyboardKeys["ArrowDown"] = "ArrowDown";
    DefinedKeyboardKeys["ArrowUp"] = "ArrowUp";
    DefinedKeyboardKeys["Comma"] = ",";
    DefinedKeyboardKeys["Dot"] = ".";
    DefinedKeyboardKeys["Enter"] = "Enter";
    DefinedKeyboardKeys["Esc"] = "Escape";
    DefinedKeyboardKeys["F"] = "f";
    DefinedKeyboardKeys["Return"] = "Return";
    DefinedKeyboardKeys["Space"] = " ";
})(DefinedKeyboardKeys || (exports.DefinedKeyboardKeys = DefinedKeyboardKeys = {}));
const onKeyboardKey = (handlerFn, keys) => (event) => {
    const { key } = event;
    if (keys.includes(key)) {
        handlerFn(event);
    }
};
exports.onKeyboardKey = onKeyboardKey;
const onEnterPress = (handlerFn) => (event) => (0, exports.onKeyboardKey)(handlerFn, [
    DefinedKeyboardKeys.Enter,
    DefinedKeyboardKeys.Return,
])(event);
exports.onEnterPress = onEnterPress;
const onEnterOrSpacePress = (handlerFn) => (event) => (0, exports.onKeyboardKey)(handlerFn, [
    DefinedKeyboardKeys.Enter,
    DefinedKeyboardKeys.Return,
    DefinedKeyboardKeys.Space,
])(event);
exports.onEnterOrSpacePress = onEnterOrSpacePress;
//# sourceMappingURL=onEnterPress.js.map